import React from 'react';
import ContainerTemplate from '../../../components/template/Container';
import TiposClasesView from './TiposClasesView';
import * as ROUTES from '../../../router/Routes';

const module = () => {
  return (
    <ContainerTemplate active={ROUTES.tiposClases} routes={[]}>
      <TiposClasesView />
    </ContainerTemplate>
  );
};

export default module;
